import { RequireSomeFields } from 'common/TypeUtilities';
import { ActiveSubscriptionFieldsFragment } from 'src/gqlReactTypings.generated.d';

export enum TabNames {
  UPCOMING = 'Upcoming',
  PREVIOUS = 'Previous',
  SUBSCRIPTIONS = 'Subscriptions',
  MEAL_PLANS = 'Weekly Shef Service',
}

export type RecurringSubscription = RequireSomeFields<
  ActiveSubscriptionFieldsFragment,
  'orderTemplate' | 'recurringPeriodDays'
>;
